/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'checkbox': {
    width: 10,
    height: 9,
    viewBox: '0 0 10 9',
    data: `<path pid="0" d="M1.707 4.497A1 1 0 0 0 .293 5.911l2.31 2.31a1 1 0 0 0 1.462-.05L9.74 1.658A1 1 0 1 0 8.232.343L3.26 6.05 1.707 4.497z" _fill="#FFF"/>`
  }
})



// WEBPACK FOOTER //
// ./src/icons/checkbox.js